export const parseSupervisorWorkJourneyConfigIds = (record: unknown): string[] => {
  if (!record || typeof record !== 'object') {
    return [];
  }

  const refs = (record as { supervisorWorkJourneys?: unknown }).supervisorWorkJourneys;
  if (!Array.isArray(refs)) {
    return [];
  }

  const ids = refs
    .map(ref => {
      if (!ref || typeof ref !== 'object') {
        return null;
      }
      const configId = (ref as { workJourneyConfigId?: unknown }).workJourneyConfigId;
      return typeof configId === 'string' && configId.trim() ? configId.trim() : null;
    })
    .filter((id): id is string => id !== null);

  return Array.from(new Set(ids));
};
